module.exports = __webpack_public_path__ + "img/icon_mouse_right.1fdbe6ad.png";